import $ from 'jquery';

var format_value = function (value) {
	return Number(value).toLocaleString("de-DE", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

var format_value_int = function (value) {
	return Number(value).toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

var removeNonDigitChars = function (value) {
	return value.replace(/\D/g, ''); // IE8 unfriendly
}

var change_input = function (elm, change) {
	jQuery("input[type=text]." + elm).val(format_value(change));
	jQuery("input[type=range]." + elm).val(change);
}

var get_query_string_value = function (key) {
	key = key.replace(/[*+?^$.\[\]{}()|\\\/]/g, "\\$&"); // escape RegEx meta chars
	var match = location.search.match(new RegExp("[?&]" + key + "=([^&]+)(&|$)"));
	return match && decodeURIComponent(match[1].replace(/\+/g, " "));
}

// global variables
// var page = 'fc'
var page = typeof asfActiveBrand !== 'undefined' ? (asfActiveBrand === 'dittbillaan' ? 'db' : 'fc') : 'fc';
var price = 200000;
var capital = 70000;
var years = 5;
var finnkode = get_query_string_value('finnkode');
var finnekap = get_query_string_value('egenkapital');
var finnpris = get_query_string_value('pris');
var finntid = get_query_string_value('nedbetalingstid');
var finnprod = get_query_string_value('product');
var finn = "";

jQuery(document).ready(function() {
	if (typeof keys !== 'undefined') {
		window.addEventListener('pageshow', function(event) {
			if (event.persisted || window.performance && 
				window.performance.navigation.type == 2) { // comes from cache
				location.reload();
			} 
		});
		initCalc();
	}
});

function initCalc() {
	// Prefill from URL params if coming from Finn
	if (finnkode !== null && finnekap !== null && finnpris !== null) {
		price   = isNaN(parseInt(finnpris)) ? 200000 : parseInt(finnpris);
		capital = isNaN(parseInt(finnekap)) ? 70000  : parseInt(finnekap);
		years   = isNaN(parseInt(finntid))  ? 7      : parseInt(finntid);
		if (finnprod == 0 || finnprod == 1 || finnprod == 2 || finnprod == 3 || finnprod == 4) {
			product_id = parseInt(finnprod);
		}
	} else {
		// Default values per product type
		if (product_id == 4) {
			price = 500000; capital = 200000; years = 10;
		} else if (product_id == 2) {
			price = 150000; capital = 52500; years = 5;
		} else {
			price = 200000; capital = 70000; years = 7;
		}
	}

	// DB always uses fixed defaults regardless of URL params
	if (page === 'db') {
		price = 200000; capital = 100000; years = 5;
		change_input("price", price);
		change_input("capital", capital);
		change_input("years", years);
		initCalcMaxMinValues(-1);
	} else {
		change_input("price", price);
		change_input("capital", capital);
		change_input("years", years);
		initCalcMaxMinValues(product_id);
	}

	calcMaxYears(product_id, price, years, capital);

	// Initialize type select
	jQuery(".result .button").html("Søk " + keys[product_id]);
	jQuery("input#" + product_id).attr('checked', true);
	jQuery(".type_selected").text(keys[product_id]);
	jQuery("input[type=range]").off('keydown');

	getAndShowResults();
}

// min/ max variables for different products
function initCalcMaxMinValues(id) {
	var price = jQuery("#price").val();
	if (id == 4) { // boat
		jQuery('.product-info').html('Betinger at båten er min. 7 m. og er/blir innreg. i Skipsregisteret NOR');
		jQuery(".product-info").show();
		jQuery("#price").attr("min", 300000);
		jQuery("#capital").attr("min", 50000);
		jQuery("#price").attr("max", 5000000);
		jQuery("#capital").attr("max", price);
	} else if (id == 2) { // mc
		jQuery(".product-info").hide();
		jQuery("#price").attr("min", 20000);
		jQuery("#capital").attr("min", 0);
		jQuery("#price").attr("max", 2000000);
		jQuery("#capital").attr("max", price);
	} else if (id == 0 || id == 3) { // car and caravan
		jQuery(".product-info").hide();
		jQuery("#price").attr("min", 30000);
		jQuery("#capital").attr("min", 0);
		jQuery("#price").attr("max", 2000000);
		jQuery("#capital").attr("max", price);
	} else if (id == 1 ) { // green car
		jQuery('.product-info').html('Grønt Billån for deg som skal kjøpe el- eller hybridbil.');
		jQuery(".product-info").show();
		jQuery("#price").attr("min", 30000);
		jQuery("#capital").attr("min", 0);
		jQuery("#price").attr("max", 2000000);
		jQuery("#capital").attr("max", price);
	} else if (id == -1) { //db
		jQuery(".product-info").hide();
		jQuery(".price").attr("min", 100000);
		jQuery("#capital").attr("min", price * 0.35);
		jQuery("#price").attr("max", 2000000);
		jQuery("#capital").attr("max", price);
		jQuery(".years").attr("max", 5);
	}
}

// max 7 years downpayment for cars, mc, caravan, priced below 100k (not valid for dittbillan!)
function calcMaxYears(product_id, price, years, capital) {
	if (page === 'db') {
		jQuery("#years").attr("max", 7);
		if (years > 7) {
			change_input("years", 7);
		}
		return;
	}
	if ((product_id == 0 ||
		product_id == 1 ||
		product_id == 2 ||
		product_id == 3) && ((price - capital) < 100000)) {
		jQuery("#years").attr("max", 7);
		if (years > 5) {
			change_input("years", 5);
		}
	} else {
		jQuery("#years").attr("max", 10);
		if (years > 10) {
			change_input("years", 7);
		}
	}
}

function applyCalcRules(elm, val) {
	var price = jQuery("#price").val();
	var capital = jQuery("#capital").val();
	var years = jQuery("#years").val();
	//var product_id = jQuery("input[name=type]").attr('id');

	switch (elm) {
		case "price":
			// limit max capital to price
			var amount = price - capital;
			if (amount <= 20000) {
				capital = price - 20000;
				change_input("capital", capital);
				jQuery("#capital").attr("max", price - 20000);
			}

			// adjust max Years
			calcMaxYears(product_id, price, years, capital);

			// adjust min/ max capital
			if (page == 'db') { // db min 35% capital
				getDittbillaanMinCapital(capital, price);
			} else {
				jQuery("#capital").attr("max", price);
			}
			break;

		case "capital":
			// limit max capital to price
			amount = price - capital;
			if (amount <= 20000) {
				capital = price - 20000;
				change_input("capital", capital);
				jQuery("#capital").attr("max", price - 20000);
			}
			// adjust max Years
			calcMaxYears(product_id, price, years, capital);
			break;

		case "years":
			break;
	}
}

// Special rule for db: min 100k or 35% capital!
function getDittbillaanMinCapital(capital, price) {
	var capitalMin = 35000;
	if (price * 0.35 >= 35000) {
		capitalMin = Math.ceil(price * 0.35);
	}
	if (capital < (price * 0.35)) {
		change_input("capital", capitalMin);
		jQuery("#capital").attr("min", capitalMin);
	} else {
		jQuery("#capital").attr("min", capitalMin);
	}
	jQuery("#capital").attr("max", price);
}

// query numbers from vendor and display results for downpayments and interest
function getAndShowResults() {
	var price = jQuery("#price").val();
	var calc_value = jQuery("#price").val();
	var capital = jQuery("#capital").val();
	var years = jQuery("#years").val();

	// Kaskofritt, dersom ikke båt
	if ((price < 100000) && (product_id != 4) && (page !== "db")) {
		jQuery(".kaskofritt").attr('aria-hidden', 'false').show();
	} else {
		jQuery(".kaskofritt").attr('aria-hidden', 'true').hide();
	}

	if (page == "fc") {
		if (finnkode != null) { // finn
			finn = "&ext.marketId=" + finnkode;
			product = lan[keys[product_id]][2];
			// if (calc_value < 100000) {
      //   if (jQuery('input.kaskofritt').is(':checked')) {
      //     product = lan[keys[product_id]][3];
      //   }
      // }
			if (calc_value < 100000 && jQuery("input.kaskofritt").is(":checked")) {
				product = lan[keys[product_id]][3];
			}
		} else {
			finn = "";
			product = lan[keys[product_id]][0];
			if (calc_value < 100000) {
				if (jQuery("input.kaskofritt").is(":checked")) {
					product = lan[keys[product_id]][1];
				}
			} else {
				product = lan[keys[product_id]][0];
			}
		}
	} else { // dittbillan
		finn = "";
		product = "DITTBILAAN";
	}

	// Zero out result fields
	jQuery(".result > .mnd > .mnd, .nom_eff .value").html("&nbsp;");
	jQuery(".loader").css("display", "inline-block");

	var url = asfCalc.ajaxurl + "?name=ok&year=" + years + "&price=" + price + "&egenkapital=" + capital + "&product=" + product;
	jQuery.getJSON(url, function(data) {
		jQuery(".loader").css("display", "none");
		jQuery(".result > .wrapper .mnd > .mnd").html(format_value(Math.round(data.TerminBelop) + data.Termingebyr));
		jQuery(".result .nom .value").html(format_value_int(data.NominellRente) + " %");
		jQuery(".result .eff .value").html(format_value_int(data.EffektivRente) + " %");
		jQuery("input[name=interest][value='" + data.NominellRente + "']").attr("checked", "checked");
	});
}


// Custom radio
jQuery(".type_selected").on("keydown", function (e) {
	e.stopPropagation();
	if (e.which == 13) {
		jQuery("div.type").toggle();
		if (jQuery("div.type").is(":visible")) {
			jQuery("input[name=type]").first().focus();
			jQuery(".type_selected").attr('aria-expanded', 'true');
		} else {
			jQuery(".type_selected").attr('aria-expanded', 'false');
		}
	}
});

jQuery(".type_selected").on("click", function (e) {
	e.stopPropagation();
	jQuery("div.type").toggle();
	if (jQuery("div.type").is(":visible")) {
		jQuery("input[name=type]").first().focus();
		jQuery(".type_selected").attr('aria-expanded', 'true');
	} else {
		jQuery(".type_selected").attr('aria-expanded', 'false');
	}
});

// Hide dropdown on click outside
// jQuery("body").on("click", function () {
// 	jQuery("div.type").hide();
// 	jQuery(".type_selected").attr('aria-expanded', 'false');
// });

// Change product type
jQuery("input[name=type]").on("change", function () {
	price = jQuery("#price").val();
	years = jQuery("#years").val();
	capital = jQuery("#capital").val();
	product_id = this.id;

	if (product_id === "4") { // boat
		change_input("price", 500000);
		change_input("capital", 200000);
		change_input("years",10);
	} else if (product_id === "2") { //mc
		change_input("price", 150000);
		change_input("capital", 52500);
		change_input("years", 5);
	} else { 
		change_input("price", 200000);
		change_input("capital", 70000);
		change_input("years",7);
	}
	calcMaxYears(product_id, price, years, capital);
	initCalcMaxMinValues(product_id);
	jQuery(".result .button").html("Søk " + keys[product_id]);
	getAndShowResults();
});

// jQuery("div.type label").on("click", function () {
// 	jQuery("div.type").hide();
// 	jQuery(".type_selected").text(jQuery(this).text());
// 	jQuery(".type_selected").attr('aria-expanded', 'false');
// });

// jQuery(".div.type label").on("keydown", function (e) {
// 	e.stopPropagation();
// 	if (e.which == 27) {
// 		jQuery("div.type").hide();
// 		jQuery(".type_selected").attr('aria-expanded', 'false');
// 	}
// });

//  jQuery("div.type label:last-child").on("blur", function () {
// 	jQuery("div.type").hide();
// 	jQuery(".type_selected").attr('aria-expanded', 'false');
// })

jQuery("div.type label").on("keypress", function (e) {
	if (e.which == 13) {
		var val = this.getAttribute("for");
		jQuery("#"+val).click();
	}
});

// Query and show result after checkbox interaction
jQuery("form input[type=checkbox]").on("input change", function () {
	getAndShowResults();
});

// Just format and update rules while sliding...
jQuery("input[type=range]").on("input change", function () {
	// round of price and capital to nearest thousand
	if (this.className === "price" || this.className === "capital") {
		this.value = Math.round(this.value/1000)*1000;
		jQuery("#" + this.className + "_text").val(format_value(Math.round(this.value/1000)*1000));
	} else {
		jQuery("#" + this.className + "_text").val(format_value(this.value));
	}
	applyCalcRules(this.className, this.value);
});

// Query and show result after slider interaction
jQuery("form input[type=range]").on("mouseup touchend", function () {
	getAndShowResults();
});

jQuery("input[type=text]").on("input", function (e) {
    if ( this.value > 1) {
        jQuery(this).val(format_value(removeNonDigitChars(this.value)));
    } else {
        jQuery(this).val(removeNonDigitChars(this.value));
    }
});

jQuery("input[type=text]").on("click", function () {
	jQuery(this).select();
});

// Query and show result on Enter
jQuery("input[type=text]").on("focusout", function () {
 	if ( this.value.length <= 0 ) {
		jQuery(this).val(format_value(removeNonDigitChars("0")));
	}
	var e = jQuery.Event('keypress', { which: 13 });
	var maxVal = jQuery("#" + this.className).attr('max');
	var minVal = jQuery("#" + this.className).attr('min');
	var inputValue = parseInt(this.value.split('.').join(''));
	if (inputValue > maxVal) {
		jQuery("#" + this.className).val(removeNonDigitChars(maxVal)).trigger(e);
		jQuery("#" + this.className + "_text").val(format_value(maxVal));
	} else if (inputValue < minVal) {
		jQuery("#" + this.className).val(removeNonDigitChars(minVal)).trigger(e);
		jQuery("#" + this.className + "_text").val(format_value(minVal));
	} else jQuery("#" + this.className).val(removeNonDigitChars(this.value)).trigger(e);
	applyCalcRules(this.className, this.value);
	getAndShowResults();
});

// Query and show result on Enter
jQuery("form input").on('keypress', function (e) {
 	if (e.which == 13) {
		jQuery(this).blur();
		
	}
});

// redirect to loan application
jQuery(".calc .button").on("click", function () {
	var calc_value = jQuery("#price").val();
	var calc_capital = jQuery("#capital").val();
	var calc_terms = jQuery("#years").val();

	if (page == "fc" && finn === "") {
        var agent = "as_financiering_direkte";
        var prod_url = "https://direkte.financiering.no";
    } else if (page == "fc" && finn !== "") {
        var agent = "finn_no";
        var prod_url = "https://direkte.financiering.no";
    } else {
        var agent = "ditt_billån_direkte";
        product = "DITTBILLAAN";
        var prod_url = "https://direkte.xn--dittbilln-d3a.no";
    }
	
	var extra_url = "";

	if (product == "KASKOFRITT_LAAN_OTHER_Internet" || product == "KASKOFRITT_LAAN_OTHER_Finn") {
		if (product_id == 2) { // MC
			extra_url = "&ext.objectTypeId=7&ext.objectSubTypeId=153";
		}
		if (product_id == 3) { // Caravan
			extra_url = "&ext.objectTypeId=7&ext.objectSubTypeId=157";
		}
	}

	var url = prod_url + "/product/" + mapping[product] + "/?ext.agent=" + agent + "&ext.objectPrice=" + calc_value + "&ext.equity=" + calc_capital + "&ext.termsInYears=" + calc_terms + finn + extra_url;
	window.location.href = url;
});
